var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ObiApp',{style:(_vm.cssProps)},[_c('router-view'),_c('notifications',{attrs:{"position":"top center","max":1,"width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }